<template>
    <div class="container mx-auto mt-10 md:mt-12 lg:mt-16 xl:mt-20 xl:px-0 px-4">
        <div class="grid items-center gap-8 md:grid-cols-2 bg-success-soft rounded-4xl">
            <div class="px-4 pt-16 text-center md:ml-12 md:px-0 md:text-left md:py-20 justify-self-center">
                <h2 v-if="slots.title" class=" text-2xl sm:text-3xl !leading-10 font-semibold" :class="{'font-inter':locale=='vi'}">
                    <slot name="title"></slot>
                </h2>
                <div v-if="slots.description" class="mt-4 md:mt-6 lg:mt-8 text-base sm:text-lg">
                    <slot name="description"></slot>
                </div>
                <slot name="action"></slot>
            </div>
            <div class="p-4" v-if="slots.image">
                <slot name="image"></slot>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { useSlots } from 'vue'
const { locale } = useI18n()
const slots = useSlots()
</script>